import {
  BlockNoteEditor,
  BlockNoteSchema,
  defaultInlineContentSpecs,
  InlineContent,
  InlineContentFromConfig,
  StyledText,
} from '@blocknote/core';

import { ContextVariable, ContextVariableTokenHighlight } from '@/hooks/ContextVariable';

/**
 * Custom BlockNote schema with ContextVariable (mention) and ContextToken support
 */
export const sharedEditorSchema = BlockNoteSchema.create({
  inlineContentSpecs: {
    ...defaultInlineContentSpecs,
    mention: ContextVariable,
    contextToken: ContextVariableTokenHighlight,
  },
});

export type SharedEditorInstance = BlockNoteEditor<
  typeof sharedEditorSchema.blockSchema,
  typeof sharedEditorSchema.inlineContentSchema,
  typeof sharedEditorSchema.styleSchema
>;

export type EditorBlockSchema = typeof sharedEditorSchema.blockSchema;
export type EditorInlineContentSchema = typeof sharedEditorSchema.inlineContentSchema;
export type EditorStyleSchema = typeof sharedEditorSchema.styleSchema;

export type SchemaInlineContent = InlineContent<EditorInlineContentSchema, EditorStyleSchema>;
export type EditorBlock = import('@blocknote/core').Block<
  EditorBlockSchema,
  EditorInlineContentSchema,
  EditorStyleSchema
>;
export type EditorTextNode = StyledText<EditorStyleSchema>;
export type EditorMentionNode = InlineContentFromConfig<
  (typeof ContextVariable)['config'],
  EditorStyleSchema
>;
export type EditorContextTokenNode = InlineContentFromConfig<
  (typeof ContextVariableTokenHighlight)['config'],
  EditorStyleSchema
>;
export type EditorInlineContent = SchemaInlineContent | EditorMentionNode | EditorContextTokenNode;
export type EditorInlineBlock = Extract<EditorBlock, { content: EditorInlineContent[] }>;
